import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";

const ROUTE_TITLES: ReadonlyArray<readonly [pattern: string, title: string]> = [
  ["/", "Özet"],
  ["/login", "Giriş"],
  ["/forgot-password", "Şifre sıfırlama"],
  ["/reset-password", "Şifre sıfırlama"],
  ["/organizers", "Organizatörler"],
  ["/organizers/:id", "Organizatör"],
  ["/orders", "Siparişler"],
  ["/orders/:orderNumber", "Sipariş"],
  ["/members", "Kullanıcılar"],
  ["/payouts", "Ödemeler"],
  ["/payment-settings", "Ödeme ayarları"],
  ["/reports", "Raporlar"],
  ["/team", "Ekip"],
  ["/audit-logs", "Kayıtlar"],
];

function setDocumentTitle(title: string) {
  document.title = `${title} · TicketNjoy Admin`;
}

export function DocumentTitle() {
  const { pathname } = useLocation();
  const title =
    ROUTE_TITLES.find(([pattern]) => matchPath(pattern, pathname))?.[1] ?? "Sayfa bulunamadı";

  useEffect(() => {
    setDocumentTitle(title);
  }, [title]);

  return null;
}
